export default function map(callback) {
    
    if(window.google) {
        callback(window.google)
        return
    } else {
        if(!window.googleMapsCallbacks)
        window.googleMapsCallbacks = []
        
        window.googleMapsCallbacks.push(callback)
    }
    
    window.initMap = () => {
        window.googleMapsCallbacks.forEach(callback => {
            callback(window.google)
        })
        window.googleLoading = false
    }
    
    if(!window.googleScriptLoaded) {
        const script = document.createElement("script")
        script.src = `https://maps.googleapis.com/maps/api/js?key=${window.gmak}&libraries=places&callback=initMap`
        script.async = true
        script.crossorigin = true
        document.body.appendChild(script)
        window.googleScriptLoaded = true
    }
}


// WEBPACK FOOTER //
// ./src/components/third-party/GoogleMap/Core.js